import { Injectable, signal, WritableSignal } from '@angular/core';
import { User } from '../shared/models/user.model';

/**
 * User State Service for Streamlined Agrar
 * Stores current user (Nenad) information in application state
 * User is always required - loaded on app initialization
 */
@Injectable({
  providedIn: 'root'
})
export class UserStateService {
  
  private readonly userSignal: WritableSignal<User | null> = signal(null);
  
  /**
   * Get current user
   * Returns user signal for reactive access
   */
  readonly user = this.userSignal.asReadonly();
  
  /**
   * Set current user
   */
  setUser(user: User): void {
    console.log('[UserStateService] Setting user:', user.fullName, user.email);
    this.userSignal.set(user);
  }
  
  /**
   * Clear user
   */
  clearUser(): void {
    console.log('[UserStateService] Clearing user');
    this.userSignal.set(null);
  }
}

